// $(document).ready(function(){
//   $('.cstm-slides').slick({ 
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: false,
//     autoplaySpeed: 7000,
//     arrows: false,
//     dots: false,
//   });
// });


$(document).ready(function() {
    // Show or hide the button depending on the scroll position
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('#backToTop').fadeIn();
        } else {
            $('#backToTop').fadeOut();
        }
    });

    // Scroll to the top when the button is clicked
    $('#backToTop').click(function() {
        $('html, body').animate({scrollTop: 0}, 600);
        return false;
    });
});



// Get Ruba button to click and scroll to product section
// var getruba = document.getElementsByClassName("header-additional-button button");

// Array.from(getruba).forEach(function(clickelem) {
//   clickelem.addEventListener("click", function() {
//       var product_section = document.getElementById("csproduct-template--18716198076669__home_featured_product_LmdPMC");
      
//       if (product_section) {
//         // console.log(product_section, "Section found!");
//         product_section.scrollIntoView({
//           behavior: 'smooth',  
//           block: 'start'     
//         });
//       } else {
//         console.log("Product section not found!");
//       }
//   });
// });
// $(".header-additional-button.button").on("click", function(e) {
//   e.preventDefault();
//   var $productSection = $("#csproduct-template--18716198076669__home_featured_product_LmdPMC");

//   if ($productSection.length) {
//     // console.log($productSection, "Section found!");
//     $productSection[0].scrollIntoView({
//       behavior: 'smooth',
//       block: 'start'
//     });
//   } else {
//     console.log("Product section not found!");
//   }
// });

$(".header-additional-button.button").on("click", function(e) {
  e.preventDefault();
  var $productSection = $("#csproduct-template--18716198076669__home_featured_product_LmdPMC");

  if (window.location.pathname === "/" || window.location.pathname === "/home") { 
    if ($productSection.length) {
      
      $productSection[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      console.log("Product section not found!");
    }
  } else {
    
    var homePageUrl = window.location.origin + "/#csproduct-template--18716198076669__home_featured_product_LmdPMC"; 
    window.location.href = homePageUrl;
  }
});

$(document).ready(function() {  
  if (window.location.hash === "#csproduct-template--18716198076669__home_featured_product_LmdPMC") {
    var $productSection = $("#csproduct-template--18716198076669__home_featured_product_LmdPMC");
    if ($productSection.length) {
      $productSection[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});





 $("li.drawer-menu__tier-1-item a").on('click', function() {
    var navtitle = $(this).text();
    
      if (navtitle == 'Shop') {
         var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        // Calculate the position to scroll to
        var targetOffset = $("#shop").offset().top  - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
      }
       if (navtitle == 'About') {
        // Get the height of the header (if it's fixed, adjust accordingly)
        var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        
        // Calculate the position to scroll to
        var targetOffset = $(".media-and-text-wrapper.template--18716198076669__media_and_text_EGf74K").offset().top - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
    }
      if (navtitle == 'Ingredients') {
        // Get the height of the header (if it's fixed, adjust accordingly)
        var headerHeight = $('.header-nav').outerHeight()+10; // Adjust selector if needed
        
        // Calculate the position to scroll to
        var targetOffset = $("#ingredients").offset().top - headerHeight;
        
        // Animate the scroll
        $('html, body').animate({
            scrollTop: targetOffset
        }, 500);
      }
     
   });

$(".customer-testimonials-header .button").on("click", function () {
  var $productSection = $("#judgeme_product_reviews");
  
  if ($productSection.length) {
     var headerHeight = $('.header-nav').outerHeight()+ 50;
    var targetOffset = $productSection.offset().top - headerHeight ;

    $('html, body').animate({
      scrollTop: targetOffset
    }, 500);
  } else {
    console.log("Product section not found!");
  }
});



// custom predictive search for blog page
document.addEventListener('DOMContentLoaded', function () {
  let inputSearch = document.querySelector('.custom_input_search');
  let resultsContainer = document.querySelector('.all_article_data_container');
  let noFound = document.querySelector('.article_not_found');

  inputSearch.addEventListener('input', async function () {
    const query = this.value.toLowerCase().trim();

    // If the input is empty, clear everything and return early
    if (query.length < 1) {
      resultsContainer.style.display = 'none';
      resultsContainer.innerHTML = ""; // Ensure previous results are cleared
      resultsContainer.classList.remove('data-not-available'); // Remove no data class
      noFound?.classList.add('hidden'); // Hide no results message
      return;
    }

    try {
      const response = await fetch(`/search/suggest?q=${encodeURIComponent(query)}&resources[type]=article&section_id=blog-predictive-search`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const result = html.querySelector('#shopify-section-blog-predictive-search');

      if (result) {
        resultsContainer.innerHTML = result.innerHTML;
        resultsContainer.style.display = "block";
        resultsContainer.classList.remove('data-not-available');
      } else {
        resultsContainer.innerHTML = "";
        resultsContainer.style.display = "none";
        resultsContainer.classList.add('data-not-available');
      }

      // Filter articles after inserting new content
      const articles = resultsContainer.querySelectorAll('.predictive-search__posts');
      let hasVisibleArticles = false;

      articles.forEach(article => {
        const articleTitle = article.dataset.title?.toLowerCase() || '';
        const articleDate = article.dataset.date?.toLowerCase() || '';
        const articleDescElement = article.querySelector('.article-description');
        const articleDesc = articleDescElement ? articleDescElement.textContent.trim().toLowerCase() : '';

        // Check if the query matches title, date, or description
        const titleCheck = articleTitle.includes(query);
        const dateCheck = articleDate.includes(query);
        const descCheck = articleDesc.includes(query);

        if (titleCheck || dateCheck || descCheck) {
          article.classList.remove("itg-hide-blog");
          hasVisibleArticles = true;
        } else {
          article.classList.add("itg-hide-blog");
        }
      });

      // If no matching articles, hide results and show "no results" message
      if (!hasVisibleArticles) {
        resultsContainer.style.display = "none";
        resultsContainer.classList.add('data-not-available');
        noFound?.classList.remove('hidden'); // Show no results message
      } else {
        resultsContainer.classList.remove('data-not-available');
        noFound?.classList.add('hidden'); // Hide no results message
      }
    } catch (error) {
      console.error("Error fetching predictive search data:", error);
    }
  });
});



// custom share all btn
async function shareContent() {
  try {
    await navigator.share({
      title: document.title,
      url: window.location.href
    });
    console.log('Shared successfully!');
  } catch (error) {
    console.log('Error sharing:', error);
  }
}



// ..........................................................................


// If the sample product is already in the cart, disable its Add to Cart button.
document.addEventListener("DOMContentLoaded", function () {
  let interval;
  const maxDuration = 5000; 
  const checkInterval = 500;
  const startTime = Date.now();

  interval = setInterval(() => {
    const button = document.querySelector(".product-form-submit-wrap .button.sample_button_ATC");
    const productId = button?.dataset.productId;

    if (!button || !productId) return;

    // Fetch cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const productInCart = cart.items.find(item => item.product_id == productId);

        if (productInCart) {
          button.disabled = true;
          button.innerText = "Already in Cart";
          button.style.backgroundColor = "#ccc";
          button.style.cursor = "not-allowed";

          clearInterval(interval);
        }
      });

    if (Date.now() - startTime > maxDuration) {
      clearInterval(interval);
    }

  }, checkInterval);
});



// function toggleOtherTextarea() {
//   const select = document.getElementById('hear_about');
//   const textarea = document.getElementById('other_hear_about');

//   if (select && textarea) {

//     textarea.style.display = (select.value === 'Other (Please Specify)') ? 'block' : 'none';
//   }
// }

// document.getElementById('hear_about')?.addEventListener('change', toggleOtherTextarea);

// window.addEventListener('DOMContentLoaded', () => {
//   toggleOtherTextarea();
// });

 // Function to show/hide textarea and change the 'name' attribute of the select field
  function toggleOtherTextarea() {
    const select = document.getElementById('hear_about');
    const textarea = document.getElementById('other_hear_about');

    if (select && textarea) {
      // If "Other (Please Specify)" is selected
      if (select.value === 'Other (Please Specify)') {
        // Change the name attribute of the select element
        select.setAttribute('name', 'none');
        textarea.style.display = 'block';  // Show the textarea
        textarea.disabled = false; // Enable textarea so the user can type
      } else {
        // If any other option is selected
        select.setAttribute('name', 'properties[How did you hear about Ruba?]'); // Restore the original name attribute
        textarea.style.display = 'none'; // Hide the textarea
        textarea.disabled = true; // Disable the textarea so it's not editable
        textarea.value = ''; // Clear the textarea value
      }
    }
  }

  // Listen for changes in the select element
  document.getElementById('hear_about')?.addEventListener('change', toggleOtherTextarea);

  // Initialize the form when the page loads
  window.addEventListener('DOMContentLoaded', () => {
    toggleOtherTextarea(); // Call the function to show/hide the textarea
  });
